<template>
    <div>
        <Header />
        <v-dialog persistent content-class="innerExPan" v-model="Loaderdialog"  id="innerExPan" >
                <v-row no-gutters>
                  <v-col cols="12" sm="12" style="text-align:center">
                    <img  :src="require('@/assets/images/loader.svg')"  />
                  </v-col>
                </v-row>
              </v-dialog>
        <v-card-text style="font-size:0.8rem !important;">
           
           <v-col cols="12">
             <v-card
               color="#fff"
               theme="light"
               style="margin-top:5px;"
             >
             <v-dialog v-model="DateModal" max-width="500px">
               <v-card>
                 <v-card-text style=" padding-top: 3em;">
                   <v-text-field label="Select Date"
                   v-model="AsOnDate"
                   required
                   dense 
                   type="date"
                   style="margin-bottom:2em;">
                 </v-text-field>
                 <v-combobox
                  v-model="BranchCode"
                  :items="BranchCodeOptions"
                 label="Select Branch"
                 :disabled="IsDisableBarnch"
             
                 dense
                ></v-combobox>
                <!-- <v-text-field 
               disabled
                v-show="!notmorethan1"
                v-model="selected_branch"
                label="Select Branch"
                >
   
                </v-text-field> -->
                
     
                  
                 </v-card-text>
     
                 <v-card-actions>
                   <v-spacer></v-spacer>
     
                   <v-btn text color="primary" @click="GetCounterSaleSummary()">ok</v-btn>
                 </v-card-actions>
               </v-card>
             </v-dialog>
             <v-card-text style="height: 20px; position: relative">
               <v-btn
                 absolute
                 dark
                 fab
                 top
                 right
                 color="blue"
                 @click="DateModal = !DateModal"
               >
                 <v-icon>mdi-calendar</v-icon>
               </v-btn>
             </v-card-text>
               <div class="d-flex flex-no-wrap justify-space-between">
                 <div style="width: 100%;text-align:left;">
                 <v-avatar
                 class="ma-3"
                 size="115"
                 rounded="0"
               >
                 <!-- <v-img :src="require('@/assets/images/bg.png')"></v-img> -->
                 <v-img src="https://img.freepik.com/free-vector/cashier-supermarket-isolated-person-smiling-woman-employee-uniform-standing-cash-desk-store-employee-working-grocery-shop-market-retail-commerce_575670-1280.jpg?w=360"></v-img>
               </v-avatar>
               <v-card-subtitle style="color:#000;padding-bottom: 0px;padding-top: 0px;text-align:left;">
                 <i class="fa fa-calendar"></i> &nbsp; {{convertDateFormat(AsOnDate)}}
                </v-card-subtitle>
                <v-card-subtitle style="color:#000;padding-bottom: 0px;padding-top: 0px;text-align:left;">
                
                 <v-avatar
                 color="green"
                 class="ma-3 "
                 size="30"
               > {{OpenedCounter}}
             </v-avatar>
               <v-avatar
               color="red"
               class="ma-3 "
               size="30"
             > {{ClosedCounter}}
             </v-avatar>
                </v-card-subtitle>
              
                
              
             </div>
                 <div style="width: 100%;text-align:right;">
                 
                   <v-card-subtitle style="color:#000;    margin-top: 5em;">
                     <v-row no-gutters>
                       <v-col cols="5" style="font-size:0.6rem; color:#000;font-weight:800;">
                        
                          Cash<br>
                          Credit<br>
                          Digital pay<br>
                          Others
                          <!-- Discount<br>
                          Tax<br>
                          Round Off -->
                         
                       </v-col>
                       <v-col cols="7">
                         <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.cash)}}</b><br>
                         <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.credit)}}</b><br>
                         <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.creditCard)}}</b><br>
                         <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.others)}}</b>
                        <!--  <b style="color:#000;">(-){{formatPrice(counteritem.discount )}}</b><br>
                         <b style="color:#000;">{{formatPrice(counteritem.tax )}}</b><br>
                         <b style="color:#000;">(-){{formatPrice(counteritem.roundOff )}}</b> -->
                       </v-col>
                     </v-row>
                    </v-card-subtitle>
                  
                   <hr style="    margin-left: 15px;">
   
                   <v-card-actions style="text-align:right;float:right; color:#000;padding-top:0px">
                   
                     Total : &nbsp;<b>{{FormatewithDecimalPlacesNew(SalesData.totSale - (SalesData.discount + SalesData.roundOff ) )}}</b> 
                    
                   </v-card-actions>
                  
                 </div>
               
   
                
               </div>
               <div class="d-flex flex-no-wrap justify-space-between">
                
                 <div style="width: 100%;text-align:left;">
                   
                   <v-card-subtitle style="color:#000;">
                     <v-col style="font-size:0.6rem; color:#000;padding-left:0px;padding-bottom: 0px;">Other Details</v-col>
                     <hr>
                     <v-row no-gutters>
                      
                       <v-col cols="5" style="font-size:0.5rem; color:#000;font-weight:800;">
                        
                          Total Tax<br>
                          Discount<br>
                          Round Off<br>
                          Sales Return
                          
                         
                       </v-col>
                       <v-col cols="7" style="text-align:right">
                         <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.tax )}}</b><br>
                         <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.discount )}}</b><br>
                         <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.roundOff )}}</b><br>
                         <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.saleReturn )}}</b><br>
                         
                       </v-col>
                     </v-row>
                    </v-card-subtitle>
                 
                  
   
                   <v-card-actions style="text-align:right;float:right; color:#000;">
                   
                   <!-- //here total   -->
                   </v-card-actions>
                 </div>
                 <div style="width: 100%;text-align:right;">
                   
                   <v-card-subtitle style="color:#000;">
                     <v-col style="font-size:0.6rem; color:#000;padding-left:0px;padding-bottom: 0px;">Cash Details</v-col>
                     <hr>
                     <v-row no-gutters>
                       <v-col cols="4" style="font-size:0.5rem; color:#000;font-weight:800;">
                        
                          Open Cash<br>
                          Cash Sale<br>
                          Payment
                          
                         
                       </v-col>
                       <v-col cols="8">
                         <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.openingAmt)}}</b><br>
                         <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.cash)}}</b><br>
                         <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.paidAmt)}}</b>
                         
                       </v-col>
                     </v-row>
                    </v-card-subtitle>
                   
                  
                   <hr style="    margin-left: 15px;">
                   <v-card-actions style="text-align:right;float:right; color:#000;padding-top:0px">
                   
                     Balance : &nbsp;<b>{{FormatewithDecimalPlacesNew( (SalesData.openingAmt + SalesData.cash )-SalesData.paidAmt )}}</b> 
                    
                   </v-card-actions>
                 </div>
               
   
                
               </div>
              
             </v-card>
             
           </v-col>
         </v-card-text>
         <!-- <v-card
         :loading="loading"
         style="margin-top: 0px !important;font-size:0.8rem !important;"
         class="mx-auto my-12"
         max-width="374"
         v-if="counterData.length != 0"
       > -->
       <v-card
         :loading="loading"
         style="margin-top: 0px !important;font-size:0.8rem !important;"
         class="mx-auto my-12"
         max-width="374"
       
       >
         
     
        
     
        
     
         <v-divider class="mx-4 mb-1"></v-divider>
     
         <v-card-actions style="font-size:0.8rem !important;" >
           <!-- <label>Counter List</label><i :class="show ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" style="text-align:right;" aria-hidden="true" @click="show = !show" ></i> -->
         <v-container >
           <v-row justify="space-between">
             <v-col  cols="10"  @click="show = !show" >
               Counter Details
             </v-col>
             <v-col  cols="2" style="text-align:right;"  @click="show = !show" >
               <i :class="show ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
             </v-col>
           </v-row>
         </v-container>
         
         </v-card-actions>
     
         <v-expand-transition>
           <div v-show="show">
             <v-divider></v-divider>
     
             <v-card-text style="font-size:0.8rem !important;padding-left: 0px;
        padding-right: 0px;">
              
               <v-col cols="12">
                 <v-card
                   color="#f1f1f1"
                   theme="light"
                   style="margin-top:10px;"
   
                   v-for="(counteritem, i) in CountersData" :key="i"
                 >
                   <div class="d-flex flex-no-wrap justify-space-between">
                     <div style="width: 100%;text-align:left;">
                     <v-avatar
                     class="ma-3"
                     size="105"
                     rounded="0"
                   >
                     <v-img :src="require('@/assets/images/bg.png')"></v-img>
                     
                   </v-avatar>
                   <v-card-subtitle style="color:#000;padding-bottom: 0px;padding-top: 0px;text-align:left;" v-if="IsShowUsers">
                    <i class="fa fa-user"></i> &nbsp; {{GetsWithComma(counteritem.Users)}}
                   </v-card-subtitle>
                   <v-card-subtitle style="color:#000;padding-top: 0px;padding-bottom: 0px;text-align:left;">
                     <i class="fa fa-calendar" ></i> &nbsp; {{convertDateFormat( counteritem.openingTime.split("T")[0]) }}
                     <br><i class="fa fa-clock-o" ></i> &nbsp; {{ counteritem.openingTime.split("T")[1] }}
                    
                   </v-card-subtitle>
                   <v-card-subtitle style="color:#000;padding-top: 0px;padding-bottom: 0px;text-align:left;" >
                     <i class="fa fa-money" ></i> &nbsp; {{FormatewithDecimalPlacesNew(counteritem.openingAmt)}}
                   </v-card-subtitle>
                   <!-- <v-card-subtitle style="color:#000;padding-top: 0px;padding-bottom: 0px;text-align:left;" v-show="counteritem.counterStatus  == 'C'"> -->
                    <v-card-subtitle style="color:#000;padding-top: 0px;padding-bottom: 0px;text-align:left;" v-show="counteritem.counterStatus  == 'C'">
                    <i class="fa fa-calendar" style="color:red;"></i> &nbsp; {{counteritem.closingTime.split("T")[0]}} 
                      <br><i class="fa fa-clock-o" style="color:red;"></i>&nbsp;  {{counteritem.closingTime.split("T")[1]}}
                    </v-card-subtitle>
                   <v-card-subtitle style="color:#000;padding-top: 0px;padding-bottom: 0px;text-align:left;" v-show="counteritem.counterStatus  == 'C'">
                    <i class="fa fa-money" style="color:red;"></i> &nbsp; {{FormatewithDecimalPlacesNew(counteritem.closingAmt)}}
                    </v-card-subtitle>
                  <v-card-subtitle style="color:#000;padding-top: 0px;padding-bottom: 0px;text-align:left;" v-show="counteritem.counterStatus  == 'C'">
                  <i class="fa fa-cubes" style="color:blue;"></i> &nbsp; {{counteritem.saleCount}} Nos
                  </v-card-subtitle>
                 </div>
                     <div style="width: 100%;text-align:right;">
                       <v-card-title class="text-h5" style="justify-content: center;">
                         <!-- <v-avatar
                         style="float:right;"
                         class="ma-3 "
                         size="55"
                         :color="counteritem.counterStatus  == 'C' ? 'red' : 'green'"
                         rounded="20"
                       > Counter 1
                       </v-avatar> -->
                       <v-avatar
                         style="float:right;"
                         class="ma-3 "
                         size="55"
                         :color="counteritem.counterStatus  == 'C' ? 'red' : 'green'"
                         rounded="20"
                       > {{counteritem.counterName}}
                       </v-avatar>
                       <br>
                       <v-btn small rounded  @click="OpenShiftWiseModal(counteritem.Shifts)" >No of shift ({{ counteritem.Shifts.length }})</v-btn>
                       
   
                       </v-card-title>
       
                       <v-card-subtitle style="color:#000;    margin-top: 2.5em;">
                         <v-row no-gutters>
                           <v-col cols="4" style="font-size:0.5rem; color:#000;">
                            
                              Cash<br>
                              Credit<br>
                              Digital pay<br>
                              Others
                              <!-- Discount<br>
                              Tax<br>
                              Round Off -->
                             
                           </v-col>
                           <v-col cols="8">
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(counteritem.cash )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(counteritem.credit )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(counteritem.creditCard )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(counteritem.others )}}</b>
                             <!-- <b style="color:#000;">(-){{formatPrice(counteritem.discount )}}</b><br>
                             <b style="color:#000;">{{formatPrice(counteritem.tax )}}</b><br>
                             <b style="color:#000;">(-){{formatPrice(counteritem.roundOff )}}</b> -->
                           </v-col>
                         </v-row>
                        </v-card-subtitle>
                      
                       <hr style="    margin-left: 15px;">
       
                       <v-card-actions style="text-align:right;float:right; color:#000;padding-top:0px">
                       
                         Total : &nbsp;<b>{{FormatewithDecimalPlacesNew(counteritem.totSale - (counteritem.discount + counteritem.roundOff ) )}}</b> 
                        
                       </v-card-actions>
                      
                     </div>
                   
       
                    
                   </div>
                   <div class="d-flex flex-no-wrap justify-space-between">
                    
                     <div style="width: 100%;text-align:left;">
                       
                       <v-card-subtitle style="color:#000;">
                         <v-col style="font-size:0.5rem; color:#000;padding-left:0px;padding-bottom: 0px;">Other Details</v-col>
                         <hr>
                         <v-row no-gutters>
                          
                           <v-col cols="5" style="font-size:0.5rem; color:#000;">
                            
                              Total Tax<br>
                              Discount<br>
                              Round Off<br>
                              Sales Return
                              
                             
                           </v-col>
                           <v-col cols="7" style="text-align:right">
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(counteritem.tax )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(counteritem.discount )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(counteritem.roundOff )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(counteritem.saleReturn )}}</b><br>
                             
                           </v-col>
                         </v-row>
                        </v-card-subtitle>
                     
                      
       
                       <v-card-actions style="text-align:right;float:right; color:#000;">
                       
                       <!-- //here total   -->
                       </v-card-actions>
                     </div>
                     <div style="width: 100%;text-align:right;">
                       
                       <v-card-subtitle style="color:#000;">
                         <v-col style="font-size:0.5rem; color:#000;padding-left:0px;padding-bottom: 0px;">Cash Details</v-col>
                         <hr>
                         <v-row no-gutters>
                           <v-col cols="4" style="font-size:0.5rem; color:#000;">
                            
                              Open Cash<br>
                              Cash Sale<br>
                              Payment
                              
                             
                           </v-col>
                           <v-col cols="8">
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(counteritem.openingAmt )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(counteritem.cash )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(counteritem.paidAmt )}}</b>
                             
                           </v-col>
                         </v-row>
                        </v-card-subtitle>
                       
                      
                       <hr style="    margin-left: 15px;">
                       <v-card-actions style="text-align:right;float:right; color:#000;padding-top:0px">
                       
                          Balance : &nbsp;<b>{{FormatewithDecimalPlacesNew( (counteritem.openingAmt + counteritem.cash )-counteritem.paidAmt )}}</b> 
                        
                       </v-card-actions>
                     </div>
                   
       
                    
                   </div>
                  
                 </v-card>
                 
               </v-col>
             </v-card-text>
             <!-- <div>
        <v-container class="d-flex justify-center align-center fill-height">
 
 <v-row>
   <v-col cols="12" style="padding: 0px 70px 0px 70px;">
     <v-img
       :src="require('@/assets/images/empty.gif')"
       style="width: 100%;height:100%;"
     ></v-img>
   </v-col>
   <v-col cols="12" style="padding: 0px 70px 0px 70px;text-align: center;">
     <span style="font-size: 20px;font-weight: 400;color: red;">No Data Found</span>
   </v-col>
 </v-row>
</v-container>
</div> -->
           </div>
         </v-expand-transition>
         
        </v-card>
        <v-dialog v-model="ShiftwiseModal" persistent max-width="600">
      <v-card>
         <v-toolbar color="FFF">
        
          <v-toolbar-title
        style="font-size: 17px;
    font-weight: 500;padding-left:10px;font-family: Times New Roman, Times, serif;"
            >Shift wise details</v-toolbar-title
          >
          <v-spacer></v-spacer>
           <v-toolbar-items>
             <v-btn dark text @click="ShiftwiseModal= false"  color="primary"> <v-icon style="padding-left: 23px;">mdi-close</v-icon> </v-btn> 
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="font-size:0.8rem !important;padding-left: 0px;
        padding-right: 0px;">
              <!-- <v-col cols="12" style="text-align: center;padding-top: 15px;
    padding-bottom: 0px;color:blue">
                <span style="text-align: center;font-size: 18px;"> Shift wise details</span>
              </v-col> -->
               <v-col cols="12" style="max-height:700px; overflow:scroll;overflow-x: hidden;">

                 <v-card
                   color="#f1f1f1"
                   theme="light"
                   style="margin-top:10px;"
   
                   v-for="(item, i) in CounterShifts" :key="i" 
                 >
                   <div class="d-flex flex-no-wrap justify-space-between">
                     <div style="width: 100%;text-align:left;">
                     <v-avatar
                     class="ma-3"
                     size="105"
                     rounded="0"
                   >
                     <v-img :src="require('@/assets/images/bg.png')"></v-img>
                     
                   </v-avatar>
                   <v-card-subtitle style="color:#000;padding-bottom: 0px;padding-top: 0px;text-align:left;">
                    <i class="fa fa-user"></i> &nbsp; {{ item.Username }}
                   </v-card-subtitle>
                   <v-card-subtitle style="color:#000;padding-top: 0px;padding-bottom: 0px;text-align:left;">
                     <i class="fa fa-calendar" ></i> &nbsp; {{ AsOnDate }}
                     <br><i class="fa fa-clock-o" ></i> &nbsp; {{ item.OpeningTime }}
                    
                   </v-card-subtitle>
                   <v-card-subtitle style="color:#000;padding-top: 0px;padding-bottom: 0px;text-align:left;" >
                     <i class="fa fa-money" ></i> &nbsp; {{FormatewithDecimalPlacesNew(item.OpeningAmount)}}
                   </v-card-subtitle>
                   <!-- <v-card-subtitle style="color:#000;padding-top: 0px;padding-bottom: 0px;text-align:left;" v-show="item.CounterStatus  == 'C'"> -->
                    <v-card-subtitle style="color:#000;padding-top: 0px;padding-bottom: 0px;text-align:left;" v-show="item.CounterStatus  == 'C'">
                    <i class="fa fa-calendar" style="color:red;"></i> &nbsp; {{AsOnDate}} 
                      <br><i class="fa fa-clock-o" style="color:red;"></i>&nbsp;  {{item.ClosingTime}}
                    </v-card-subtitle>
                   <v-card-subtitle style="color:#000;padding-top: 0px;padding-bottom: 0px;text-align:left;" v-show="item.CounterStatus  == 'C'">
                    <i class="fa fa-money" style="color:red;"></i> &nbsp; {{FormatewithDecimalPlacesNew(item.ClosingAmount)}}
                    </v-card-subtitle>
                  <v-card-subtitle style="color:#000;padding-top: 0px;padding-bottom: 0px;text-align:left;" v-show="item.CounterStatus  == 'C'">
                  <i class="fa fa-cubes" style="color:blue;"></i> &nbsp; {{item.SaleCount}} Nos
                  </v-card-subtitle>
                 </div>
                     <div style="width: 100%;text-align:right;">
                       <v-card-title class="text-h5" style="justify-content: center;">
                         <!-- <v-avatar
                         style="float:right;"
                         class="ma-3 "
                         size="55"
                         :color="item.CounterStatus  == 'C' ? 'red' : 'green'"
                         rounded="20"
                       > Counter 1
                       </v-avatar> -->
                       <v-avatar
                         style="float:right;"
                         class="ma-3 "
                         size="55"
                         :color="item.CounterStatus  == 'C' ? 'red' : 'green'"
                         rounded="20"
                       > {{item.CounterName}}
                       </v-avatar>
                    
                       </v-card-title>
       
                       <v-card-subtitle style="color:#000;    margin-top: 2.5em;">
                         <v-row no-gutters>
                           <v-col cols="4" style="font-size:0.5rem; color:#000;">
                            
                              Cash<br>
                              Credit<br>
                              Digital pay<br>
                              Others
                              <!-- Discount<br>
                              Tax<br>
                              Round Off -->
                             
                           </v-col>
                           <v-col cols="8">
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(item.CashSaleAmt )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(item.DebitSaleAmt )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(item.CreditSaleAmt )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(item.DiscountVoucher )}}</b>
                             <!-- <b style="color:#000;">(-){{formatPrice(item.Discount )}}</b><br>
                             <b style="color:#000;">{{formatPrice(item.Tax )}}</b><br>
                             <b style="color:#000;">(-){{formatPrice(item.RoundOff )}}</b> -->
                           </v-col>
                         </v-row>
                        </v-card-subtitle>
                      
                       <hr style="    margin-left: 15px;">
       
                       <v-card-actions style="text-align:right;float:right; color:#000;padding-top:0px">
                       
                         Total : &nbsp;<b>{{FormatewithDecimalPlacesNew(item.TotSaleAmt - (item.TotDiscount + item.TotRoundOff) )}}</b> 
                        
                       </v-card-actions>
                      
                     </div>
                   
       
                    
                   </div>
                   <div class="d-flex flex-no-wrap justify-space-between">
                    
                     <div style="width: 100%;text-align:left;">
                       
                       <v-card-subtitle style="color:#000;">
                         <v-col style="font-size:0.5rem; color:#000;padding-left:0px;padding-bottom: 0px;">Other Details</v-col>
                         <hr>
                         <v-row no-gutters>
                          
                           <v-col cols="5" style="font-size:0.5rem; color:#000;">
                            
                              Total Tax<br>
                              Discount<br>
                              Round Off<br>
                              Sales Return
                              
                             
                           </v-col>
                           <v-col cols="7" style="text-align:right">
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(item.Tax )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(item.TotDiscount )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(item.TotRoundOff )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(item.SalesReturn )}}</b><br>
                             
                           </v-col>
                         </v-row>
                        </v-card-subtitle>
                     
                      
       
                       <v-card-actions style="text-align:right;float:right; color:#000;">
                       
                       <!-- //here total   -->
                       </v-card-actions>
                     </div>
                     <div style="width: 100%;text-align:right;">
                       
                       <v-card-subtitle style="color:#000;">
                         <v-col style="font-size:0.5rem; color:#000;padding-left:0px;padding-bottom: 0px;">Cash Details</v-col>
                         <hr>
                         <v-row no-gutters>
                           <v-col cols="4" style="font-size:0.5rem; color:#000;">
                            
                              Open Cash<br>
                              Cash Sale<br>
                              Payment
                              
                             
                           </v-col>
                           <v-col cols="8">
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(item.OpeningAmount )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(item.CashSaleAmt )}}</b><br>
                             <b style="color:#000;">{{FormatewithDecimalPlacesNew(item.PaidAmount )}}</b>
                             
                           </v-col>
                         </v-row>
                        </v-card-subtitle>
                       
                      
                       <hr style="    margin-left: 15px;">
                       <v-card-actions style="text-align:right;float:right; color:#000;padding-top:0px">
                       
                          Balance : &nbsp;<b>{{FormatewithDecimalPlacesNew( (item.OpeningAmount + item.CashSaleAmt )-item.PaidAmount )}}</b> 
                        
                       </v-card-actions>
                     </div>
                   
       
                    
                   </div>
                  
                 </v-card>
                 
               </v-col>
             </v-card-text>
      </v-card>
     </v-dialog>
              
          
    </div>
  </template>
  <script>
  import Header from "../Pages/Header.vue";
  import axios from "axios";
  export default {
    components: {
      Header
    },
    data() {
      return {
        show: false,
        DateModal:false,
         check_date:null,
         AsOnDate:new Date().toISOString().substr(0, 10),
         BranchCodeOptions:JSON.parse(localStorage.getItem('Branches')),
         BranchCode:"",
         IsDisableBarnch : false,
         bURL : localStorage.getItem('BaseURL'),
         SalesData: {
          "cash" : 0,
          "credit" : 0,
          "creditCard" :0,
          "others" :0,
          "tax" : 0,
          "discount" : 0,
          "roundOff" : 0,
          "saleReturn" : 0,
          "openingAmt" : 0,
          "paidAmt" : 0
         },
         CountersData:[],
         OpenedCounter:0,
         ClosedCounter:0,
         Loaderdialog:false,
         ShiftwiseModal:false,
         CounterShifts:[],
         IsShowUsers:false
   
      };
    },
    mounted() {
    
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = today.getFullYear();

        // today = yyyy + '-' + mm + '-' + '21';//dd ;
        today = yyyy + '-' + mm + '-' + dd ;
        this.TodayDate = today
        this.check_date = today;
        this.UserDetails = JSON.parse(localStorage.getItem('User'))
        this.BranchCode = this.UserDetails.branchCode
        if(this.BranchCode === "#" || this.BranchCode === "" || this.BranchCode === "null" || this.BranchCode === null)
        {
          this.BranchCode = ""
        }
        else if(this.UserDetails.userType !== "Administrator")
        {
          this.IsDisableBarnch = true
        }
        
        this.CounterSaleDate = localStorage.getItem('CounterSaleDate')
        this.CounterSaleBranch =  localStorage.getItem('CounterSaleBranch')
        if(this.CounterSaleDate !== null && this.CounterSaleBranch !== null)
        {
          this.AsOnDate = this.CounterSaleDate
          this.BranchCode = this.CounterSaleBranch 
        } 
        this.GetCounterSaleSummary()
    },
    methods: {
      GetCounterSaleSummary()
      {
        /* console.log(this.bURL + "/api/counter/GetCounterSaleSummary?ForDate="+this.AsOnDate+"&BranchCode="+this.BranchCode+"&WithSummary=true")
        debugger */
        axios.get(this.bURL + "/api/counter/GetCounterSaleSummary?ForDate="+this.AsOnDate+"&BranchCode="+this.BranchCode+"&WithSummary=true")
          .then(
            (response) => {
              this.SalesData = response.data.result[0]
              this.CountersData = response.data.result

              this.GetShiftWiseCounterSaleSummary()
              this.DateModal = false
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
      },
      GetShiftWiseCounterSaleSummary()
      {
        /* console.log(this.bURL + "/api/counter/GetCounterSaleSummary?ForDate="+this.AsOnDate+"&BranchCode="+this.BranchCode+"&WithSummary=true")
        debugger */
        axios.get(this.bURL + "/api/counter/GetShiftWiseCounterSaleSummary?ForDate="+this.AsOnDate+"&BranchCode="+this.BranchCode)
          .then(
            (response) => {
              this.ShiftWiseCounter = response.data
              for(this.i=0;this.i<this.CountersData.length;this.i++)
              {
                this.CountersData[this.i].Shifts = []
                this.CountersData[this.i].Users = []
                for(this.j=this.ShiftWiseCounter.length-1;this.j>-1;this.j--)
                {
                   if(this.CountersData[this.i].counterId === this.ShiftWiseCounter[this.j].CounterId)
                   {
                    this.CountersData[this.i].Shifts.push(this.ShiftWiseCounter[this.j])
                    
                    if(this.ShiftWiseCounter[this.j].ClosingTime === null || this.ShiftWiseCounter[this.j].ClosingTime === 'null')
                    {
                      this.CountersData[this.i].counterStatus = 'O'
                      this.ShiftWiseCounter[this.j].CounterStatus ='O'
                    }
                    else{
                      this.CountersData[this.i].closingTime = this.AsOnDate + "T" + this.ShiftWiseCounter[this.j].ClosingTime
                      this.CountersData[this.i].counterStatus = 'C'
                      this.ShiftWiseCounter[this.j].CounterStatus ='C'
                      this.CountersData[this.i].closingAmount = this.ShiftWiseCounter[this.j].ClosingAmount
                    }
                    if(this.CountersData[this.i].Users.includes(this.ShiftWiseCounter[this.j].Username) === false)
                    {
                      this.CountersData[this.i].Users.push(this.ShiftWiseCounter[this.j].Username)
                    }
                   }
                   
                   
                }
              }

             
              this.CountersData.splice(0,1)
              this.ClosedCounter = 0
              this.OpenedCounter = 0
              
              for(this.i=0;this.i<this.CountersData.length;this.i++)
              {
               
                if(this.CountersData[this.i].counterStatus === "C")
                {
                  this.ClosedCounter ++
                }
                if(this.CountersData[this.i].counterStatus === "O" || this.CountersData[this.i].counterStatus === "null" || this.CountersData[this.i].counterStatus === null)
                {
                  this.OpenedCounter ++
                }
              }
              this.IsShowUsers = true
              this.DateModal = false
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
      },
      OpenShiftWiseModal(CounterShifts)
      {
        if(CounterShifts.length > 1)
       {
        this.CounterShifts = CounterShifts
        this.ShiftwiseModal=true
       }
      },
      FormatewithDecimalPlacesNew(value) {
        this.number = localStorage.getItem("symbol");
        //let val = (value / 1).toFixed(this.number).replace(".", ".");
        //return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        value = parseFloat(value);
        if(isNaN(value)  === true)
        {
          value = 0
        }
        return value.toFixed(this.number);
      
    },
    GetsWithComma(values) {
      values = values.join(",");

      return values;
    },
    convertDateFormat(dateString) {
    // Split the date string into components
    const [year, month, day] = dateString.split("-");
    
    // Return the new format
    return `${day}-${month}-${year}`;
  },

     
    }
  };
  </script>
  